import { useEffect, useRef } from 'react';
import { useAuth } from 'hooks/useAuth';

export const SignOut = () => {
  const { signOut } = useAuth();
  // signOut changes identity as each sign-out updates Kinde's state, so without
  // this the effect would sign out again on every change
  const hasSignedOutRef = useRef(false);

  useEffect(() => {
    if (hasSignedOutRef.current) return;
    hasSignedOutRef.current = true;
    signOut();
  }, [signOut]);

  return null;
};
